import SectionHeading from "./SectionHeading";
import { featuredWorks } from "@/mocks/doujinData";

const tagStyles: Record<string, string> = {
  primary: "bg-primary-100 text-primary-700",
  accent: "bg-accent-100 text-accent-700",
  secondary: "bg-secondary-100 text-secondary-700",
};

export default function HotWorks() {
  return (
    <section id="hot" className="py-16 md:py-24 bg-background-50">
      <div className="container-x">
        <SectionHeading
          eyebrow="热门推荐"
          title="本周人气画集与图包"
          desc="画质清晰、题材丰富的热门同人作品精选，适合收藏与参考，持续更新中。"
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {featuredWorks.map((work) => (
            <a
              key={work.id}
              href="#gallery"
              className="group rounded-xl overflow-hidden bg-background-100 border border-background-200 transition-transform duration-300 hover:-translate-y-1"
            >
              <div className="relative overflow-hidden">
                <img
                  src={work.image}
                  alt={`${work.title} - 同人本子${work.tag}在线浏览`}
                  className="w-full aspect-[4/5] object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <span
                  className={`absolute top-3 left-3 px-2.5 py-1 rounded-full text-xs font-semibold ${tagStyles[work.tagColor]}`}
                >
                  {work.tag}
                </span>
                <span className="absolute bottom-3 right-3 px-2.5 py-1 rounded-md bg-foreground-950/60 backdrop-blur text-background-50 text-xs">
                  {work.pages} 页
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-base md:text-lg text-foreground-950 line-clamp-1">
                  {work.title}
                </h3>
                <p className="mt-1 text-sm text-foreground-600">作者：{work.author}</p>
                <div className="mt-3 flex items-center justify-between">
                  <span className="inline-flex items-center gap-1.5 text-xs text-primary-600 font-medium">
                    <i className="ri-eye-line"></i>
                    {work.price}
                  </span>
                  <span className="text-xs text-foreground-500">{work.update}</span>
                </div>
              </div>
            </a>
          ))}
        </div>

        <div className="mt-10 text-center">
          <a
            href="#gallery"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-md border border-primary-300 text-primary-700 text-sm font-semibold hover:bg-primary-50 transition-colors whitespace-nowrap"
          >
            浏览全部作品
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}